var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 21.1438 0 11.7157 5.85786 5.85786C11.7157 0 21.1438 0 40 0H42C60.8562 0 70.2843 0 76.1421 5.85786C82 11.7157 82 21.1438 82 40V42C82 60.8562 82 70.2843 76.1421 76.1421C70.2843 82 60.8562 82 42 82H40C21.1438 82 11.7157 82 5.85786 76.1421C0 70.2843 0 60.8562 0 42V40Z",
    fill: "#5667FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.125 26.5625H48.875C48.1501 26.5625 47.5625 27.1501 47.5625 27.875V33.125C47.5625 33.8499 48.1501 34.4375 48.875 34.4375H54.125C54.8499 34.4375 55.4375 33.8499 55.4375 33.125V27.875C55.4375 27.1501 54.8499 26.5625 54.125 26.5625Z",
    fill: "#5667FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.875 26.6367H33.125C33.8089 26.6367 34.3633 27.1911 34.3633 27.875V33.125C34.3633 33.8089 33.8089 34.3633 33.125 34.3633H27.875C27.1911 34.3633 26.6367 33.8089 26.6367 33.125V27.875C26.6367 27.1911 27.1911 26.6367 27.875 26.6367Z",
    fill: "#5667FF",
    stroke: "#5667FF",
    strokeWidth: 0.148438
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.875 47.6367H54.125C54.8089 47.6367 55.3633 48.1911 55.3633 48.875V54.125C55.3633 54.8089 54.8089 55.3633 54.125 55.3633H48.875C48.1911 55.3633 47.6367 54.8089 47.6367 54.125V48.875C47.6367 48.1911 48.1911 47.6367 48.875 47.6367Z",
    fill: "#5667FF",
    stroke: "#5667FF",
    strokeWidth: 0.148438
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.875 47.6367H33.125C33.8089 47.6367 34.3633 48.1911 34.3633 48.875V54.125C34.3633 54.8089 33.8089 55.3633 33.125 55.3633H27.875C27.1911 55.3633 26.6367 54.8089 26.6367 54.125V48.875C26.6367 48.1911 27.1911 47.6367 27.875 47.6367Z",
    fill: "#5667FF",
    stroke: "#5667FF",
    strokeWidth: 0.148438
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.125 26.5625H48.875C48.1501 26.5625 47.5625 27.1501 47.5625 27.875V33.125C47.5625 33.8499 48.1501 34.4375 48.875 34.4375H54.125C54.8499 34.4375 55.4375 33.8499 55.4375 33.125V27.875C55.4375 27.1501 54.8499 26.5625 54.125 26.5625Z",
    stroke: "#5667FF",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.125 26.5625H27.875C27.1501 26.5625 26.5625 27.1501 26.5625 27.875V33.125C26.5625 33.8499 27.1501 34.4375 27.875 34.4375H33.125C33.8499 34.4375 34.4375 33.8499 34.4375 33.125V27.875C34.4375 27.1501 33.8499 26.5625 33.125 26.5625Z",
    stroke: "#5667FF",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.125 47.5625H48.875C48.1501 47.5625 47.5625 48.1501 47.5625 48.875V54.125C47.5625 54.8499 48.1501 55.4375 48.875 55.4375H54.125C54.8499 55.4375 55.4375 54.8499 55.4375 54.125V48.875C55.4375 48.1501 54.8499 47.5625 54.125 47.5625Z",
    stroke: "#5667FF",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.125 47.5625H27.875C27.1501 47.5625 26.5625 48.1501 26.5625 48.875V54.125C26.5625 54.8499 27.1501 55.4375 27.875 55.4375H33.125C33.8499 55.4375 34.4375 54.8499 34.4375 54.125V48.875C34.4375 48.1501 33.8499 47.5625 33.125 47.5625Z",
    stroke: "#5667FF",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 47.5625V34.4375",
    stroke: "#5667FF",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5625 51.5H34.4375",
    stroke: "#5667FF",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 34.4375V47.5625",
    stroke: "#5667FF",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4375 30.5H47.5625",
    stroke: "#5667FF",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon-1.a0432758fe7c5ab68b7fb0309fb867fb.svg";
export { ForwardRef as ReactComponent };